import { render, staticRenderFns } from "./GroupByVessel.vue?vue&type=template&id=70b480da&"
import script from "./GroupByVessel.vue?vue&type=script&lang=js&"
export * from "./GroupByVessel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports